import React from "react";
import { joinClasses } from "./resultsPrimitives/shared.js";

function normalizePercentage(value) {
  const numericValue = Number(value);

  return Number.isFinite(numericValue) ? numericValue : 0;
}

export function getTruckLoadProgressTone(percentage) {
  const normalizedPercentage = normalizePercentage(percentage);

  if (normalizedPercentage >= 100) {
    return {
      fillColor: "var(--color-progress-over)",
      textClassName: "text-slate-500",
    };
  }

  if (normalizedPercentage > 80) {
    return {
      fillColor: "var(--color-progress-warn)",
      textClassName: "text-slate-500",
    };
  }

  return {
    fillColor: "var(--color-accent)",
    textClassName: "text-slate-500",
  };
}

export default function TruckLoadProgressBar({
  className = "h-1",
  fillClassName = "",
  percentage = 0,
  trackClassName = "",
}) {
  const normalizedPercentage = normalizePercentage(percentage);
  const safePercentage = Math.max(0, Math.min(normalizedPercentage, 100));
  const tone = getTruckLoadProgressTone(normalizedPercentage);

  return (
    <div
      className={joinClasses([
        "overflow-hidden rounded-[3px] bg-[rgba(121,108,90,0.08)]",
        className,
        trackClassName,
      ])}
    >
      <div
        className={joinClasses([
          "h-full rounded-[3px] transition-all duration-300",
          fillClassName,
        ])}
        style={{
          width: `${safePercentage}%`,
          backgroundColor: tone.fillColor,
        }}
      />
    </div>
  );
}
